module.exports = __webpack_public_path__ + "img/details_4.acd95f40.jpg";